// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchResults_container__PgO2E","spinner":"SearchResults_spinner__3kGVt"};